import React from 'react';
import Timetable from "./Timetable";

function PortTimetable(props) {
    return (
        <Timetable {...props} usePortLabels={true} />
    );
}

export default PortTimetable;